import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'

interface BrandMarkProps {
    className?: string
}

/** Shield mark, drawn as code so it stays crisp at any size. */
export const BrandMark: FC<BrandMarkProps> = ({ className }): ReactNode => {
    return (
        <svg viewBox='0 0 64 64' className={cn('size-9 shrink-0', className)} aria-hidden='true'>
            <rect width='64' height='64' rx='16' style={{ fill: 'var(--primary)' }} />
            <path d='M32 13 47 19v11c0 10.5-6.4 18.4-15 21-8.6-2.6-15-10.5-15-21V19l15-6Z' fill='none' style={{ stroke: 'var(--primary-foreground)' }} strokeWidth='4' strokeLinejoin='round' />
            <path d='m25 32 5 5 9-10' fill='none' style={{ stroke: 'var(--primary-foreground)' }} strokeWidth='4' strokeLinecap='round' strokeLinejoin='round' />
        </svg>
    )
}
